import React, { memo, useState, useCallback } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import CommonDialog from "../../../../components/CommonDialog";
import { NOTE_SAVE_TYPE } from "../../../../store/notesSlice";
import { MAX_CHAR_LENGTH } from "../index";

function NotesDialog({
  open = false,
  onClose,
  handleSubmit,
  value = "",
  dialogInputChange,
  onNoteTypeSaveChange,
  saveTypeValue = NOTE_SAVE_TYPE[0],
  list = [],
}) {
  const [duplicateError, setDuplicateError] = useState("");

  const handleInputChange = useCallback(
    (event) => {
      const userInput = event?.target?.value || "";
      const isExist =
        list.find(
          (note) =>
            note?.title?.toLowerCase().trim() ===
            userInput?.toLowerCase().trim()
        ) ?? false;
      setDuplicateError(isExist ? "Note must be unique" : "");
      dialogInputChange(event);
    },
    [dialogInputChange, list]
  );

  const onDialogClose = useCallback(() => {
    onClose?.();
    setDuplicateError("");
  }, [onClose]);

  const onDialogSubmit = useCallback(
    (event) => {
      handleSubmit?.(event);
      setDuplicateError("");
    },
    [handleSubmit]
  );

  return (
    <CommonDialog
      open={open}
      title="New Note"
      content={
        <Grid container>
          <Grid item xs={12} md={12} lg={12}>
            <FormControl>
              <FormLabel id="type-group-label">
                Where do you want to add this note?
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="type-group-label"
                name="type-radio-buttons-group"
                defaultValue={saveTypeValue}
                onChange={onNoteTypeSaveChange}
              >
                {NOTE_SAVE_TYPE.map((type) => (
                  <FormControlLabel
                    key={type}
                    value={type}
                    control={<Radio />}
                    label={`${type} Level`}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <TextField
              fullWidth
              autoComplete="off"
              autoFocus
              margin="dense"
              id="name"
              value={value}
              onChange={handleInputChange}
              label="Description"
              type="text"
              variant="standard"
              inputProps={{
                maxlength: MAX_CHAR_LENGTH,
              }}
              error={!!duplicateError}
              helperText={duplicateError}
            />
          </Grid>
        </Grid>
      }
      type="cancelSave"
      handleClose={onDialogClose}
      handleDone={onDialogSubmit}
      disableDone={!!duplicateError}
    />
  );
}

export default memo(NotesDialog);
